import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

export default function Faq() {
  const [aberto, setAberto] = useState(null);

  const toggle = (index) => {
    setAberto(aberto === index ? null : index);
  };

  // Dados estruturados do FAQ para o Google, gerados a partir das mesmas perguntas
  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.pergunta,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.resposta.split('\n').map((l) => l.trim()).filter(Boolean).join(' '),
      },
    })),
  };

  return (
    <section
      id="faq"
      className="bg-verde-novo py-5"
      style={{ scrollMarginTop: '90px' }}
    >
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqLd)}</script>
      </Helmet>

      <div className="container">
        <div className="row align-items-start">

          {/* COLUNA ESQUERDA */}
          <div className="col-md-5 mb-4 mb-md-0">
            <h2 className="text-marrom-suave mb-3">Perguntas Frequentes</h2>
            <h5 className="fw-normal mb-3">Ficou com alguma dúvida?</h5>
            <p className="mb-4">
              Estou aqui para te apoiar nesse primeiro passo em direção ao autoconhecimento
              e ao cuidado com a sua saúde emocional. Será um prazer acolher a sua história.
            </p>
          </div>

          {/* COLUNA DIREITA — ACCORDION */}
          <div className="col-md-7">
            <div className="accordion">

              {faqItems.map((item, index) => {
                const isOpen = aberto === index;

                return (
                  <div className="accordion-item mb-2" key={index}>
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${!isOpen ? 'collapsed' : ''}`}
                        type="button"
                        onClick={() => toggle(index)}
                      >
                        {item.pergunta}
                      </button>
                    </h2>

                    <div className={`accordion-collapse ${isOpen ? 'show' : 'collapse'}`}>
                      <div className="accordion-body">

                        {Array.isArray(item.resposta) ? (
                          <ul className="mb-0 ps-3">
                            {item.resposta.map((linha, i) => (
                              <li key={i} className="mb-2">{linha}</li>
                            ))}
                          </ul>
                        ) : (
                          item.resposta
                            .split('\n')
                            .filter(Boolean)
                            .map((linha, i) => (
                              <p key={i} className="mb-2">{linha.trim()}</p>
                            ))
                        )}

                      </div>
                    </div>
                  </div>
                );
              })}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ======================
   PERGUNTAS E RESPOSTAS
====================== */

const faqItems = [
  {
    pergunta: 'Como saber se preciso de terapia?',
    resposta: `
A terapia pode ajudar quando está difícil lidar sozinho(a) com emoções, pensamentos ou desafios do dia a dia, como ansiedade, estresse, esgotamento, baixa autoestima, conflitos nos relacionamentos ou momentos de mudança.`,
  },
  {
    pergunta: 'A terapia é apenas para quem está em crise?',
    resposta: `
Não. A terapia também é um espaço de autoconhecimento, desenvolvimento pessoal e cuidado emocional.`,
  },
  {
    pergunta: 'Qual público você atende?',
    resposta: `
Adolescentes, adultos e idosos.

Com adolescentes, trabalho temas como autoestima, conflitos familiares, desafios escolares e escolhas para o futuro. Com idosos, acolho mudanças como aposentadoria, perdas e novos projetos de vida.`,
  },
  {
    pergunta: 'A terapia ajuda na maternidade e na paternidade?',
    resposta: `
Sim. Tentativas de engravidar, gestação, puerpério e criação dos filhos são fases de muitas mudanças, e a terapia apoia no manejo da culpa, do cansaço e das expectativas.`,
  },
  {
    pergunta: 'Você também atende questões de carreira?',
    resposta: `
Sim. Acompanho mudança de área, recolocação, liderança e estresse no trabalho.

Também aplico a avaliação DISC, que mostra seu perfil comportamental: como você age, se comunica e toma decisões, com seus pontos fortes e aspectos a desenvolver.`,
  },
  {
    pergunta: 'Como funcionam as sessões?',
    resposta: `
As sessões acontecem online, com duração média de 50 minutos.

Geralmente são semanais, e a frequência pode ser ajustada conforme a sua necessidade.`,
  },
  {
    pergunta: 'A terapia é sigilosa?',
    resposta: `
Sim. Todo atendimento segue o sigilo profissional, conforme o Código de Ética do Psicólogo.`,
  },
  {
    pergunta: 'Você atende por convênio? Como é o pagamento?',
    resposta: `
O atendimento é particular, com pagamento via Pix.

Caso necessário, emito recibo para solicitação de reembolso junto ao convênio.`,
  },
];